import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-ag-action-cell-doc-render',
  templateUrl: './ag-action-cell-doc-render.component.html',
  styleUrls: ['./ag-action-cell-doc-render.component.css']
})
export class AgActionCellDocRendererComponent implements OnInit, ICellRendererAngularComp {
  public params: any;
  constructor() { }
  public ngOnInit(): void {
  }

  public agInit(params: any): void {
    this.params = params;
  }

  public refresh(): boolean {
    return false;
  }

  public onSelect(): void {
   // this.params.context.componentParent.onSelect(this.params.data);
    console.log('params', this.params.data);
  }
  docClick() {
    this.params.context.componentParent.docClick(this.params.data);
  }
}
